import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6563e85f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-14 ant-col-xl-14" }
const _hoisted_8 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_9 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_10 = { class: "ss-card-tela-titulo" }
const _hoisted_11 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_12 = { class: "ant-col ant-col-xl-24 ant-col-xs-24" }
const _hoisted_13 = { class: "ant-col ant-col-xs-7 ant-col-xl-7" }
const _hoisted_14 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_15 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_17 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-top":"10px","margin-bottom":"0px"}
}, null, -1))
const _hoisted_20 = { class: "ant-row" }
const _hoisted_21 = { class: "ant-col ant-col-xs-19 ant-col-xl-19" }
const _hoisted_22 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_card = _resolveComponent("card")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 900,
    centered: "",
    "wrap-class-name": "ss-modal-cadastros"
  }, {
    title: _withCtx(() => [
      _createTextVNode(" Cadastro de Caixas "),
      _createVNode(_component_a_switch, {
        checked: _ctx.state.caixa.conta.ativo,
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.caixa.conta.ativo) = $event)),
        style: {"float":"right"},
        "checked-children": "Ativa",
        "un-checked-children": "Inativa"
      }, null, 8, ["checked"])
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir) || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(true)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(false)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_a_form_item, {
                        label: "Empresa",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_empresa, {
                            codigoSelecionado: _ctx.state.caixa.conta.codigoEmpresa,
                            "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.caixa.conta.codigoEmpresa) = $event)),
                            empresasEspecificas: _ctx.telaBase.empresasDisponiveis
                          }, null, 8, ["codigoSelecionado", "empresasEspecificas"])
                        ]),
                        _: 1
                      })
                    ])
                  ], 512), [
                    [_vShow, _ctx.telaBase.apresentarEmpresas]
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_a_form_item, {
                        label: "Descrição",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            maxlength: "250",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.caixa.conta.descricao) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.caixa.conta.descricao]
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo de Documento",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_documento_financeiro, {
                            empresas: [_ctx.state.caixa.conta.codigoEmpresa],
                            codigoSelecionado: _ctx.state.caixa.codigoTipoDocumentoFinanceiro,
                            "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.caixa.codigoTipoDocumentoFinanceiro) = $event))
                          }, null, 8, ["empresas", "codigoSelecionado"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_a_form_item, {
                        label: "Saldo Inicial Padrão",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            monetario: true,
                            quantidadeCasasDecimais: 2,
                            valor: _ctx.state.caixa.saldoInicialPadrao,
                            "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.caixa.saldoInicialPadrao) = $event))
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_a_form_item, {
                        label: "Fundo de Caixa Mínimo",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            monetario: true,
                            quantidadeCasasDecimais: 2,
                            valor: _ctx.state.caixa.fundoCaixaMinimo,
                            "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.caixa.fundoCaixaMinimo) = $event))
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_card, { titulo: " " }, {
                AcoesExtra: _withCtx(() => [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.state.caixa.conta.usuariosEspecificos,
                      "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.caixa.conta.usuariosEspecificos) = $event)),
                      onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.limparUsuarios()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("ESPECIFICAR OPERADORES")
                      ]),
                      _: 1
                    }, 8, ["checked"])
                  ])
                ]),
                default: _withCtx(() => [
                  (_ctx.state.caixa.conta.usuariosEspecificos)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_a_form_item, {
                            label: "Usuários",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_selecionar_usuario, {
                                codigosSelecionados: _ctx.state.usuarios,
                                "onUpdate:codigosSelecionados": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.usuarios) = $event)),
                                varios: true,
                                empresas: [_ctx.state.caixa.conta.codigoEmpresa],
                                placeholder: ''
                              }, null, 8, ["codigosSelecionados", "empresas"]), [
                                [_vShow, _ctx.state.caixa.conta.usuariosEspecificos]
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_card, { titulo: "CONTAS DE FECHAMENTO PADRÃO" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.caixa.contasFechamento, (transferencia, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "ant-row",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_selecionar_conta, {
                          title: "Conta de Destino",
                          empresas: [_ctx.props.operacao.empresaSelecionada],
                          codigoSelecionado: _ctx.state.caixa.contasFechamento[index].codigoConta,
                          "onUpdate:codigoSelecionado": ($event: any) => ((_ctx.state.caixa.contasFechamento[index].codigoConta) = $event)
                        }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_a_form_item, {
                          label: "Categoria de Origem",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_categoria_plano_conta, {
                              empresas: [_ctx.props.operacao.empresaSelecionada],
                              "codigo-selecionado": _ctx.state.caixa.contasFechamento[index].codigoPlanoContaCategoriaOrigem,
                              "onUpdate:codigoSelecionado": ($event: any) => ((_ctx.state.caixa.contasFechamento[index].codigoPlanoContaCategoriaOrigem) = $event)
                            }, null, 8, ["empresas", "codigo-selecionado", "onUpdate:codigoSelecionado"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_a_form_item, {
                          label: "Categoria de Destino",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_categoria_plano_conta, {
                              empresas: [_ctx.props.operacao.empresaSelecionada],
                              "codigo-selecionado": _ctx.state.caixa.contasFechamento[index].codigoPlanoContaCategoriaDestino,
                              "onUpdate:codigoSelecionado": ($event: any) => ((_ctx.state.caixa.contasFechamento[index].codigoPlanoContaCategoriaDestino) = $event)
                            }, null, 8, ["empresas", "codigo-selecionado", "onUpdate:codigoSelecionado"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              monetario: true,
                              valor: _ctx.state.caixa.contasFechamento[index].valor,
                              "onUpdate:valor": [($event: any) => ((_ctx.state.caixa.contasFechamento[index].valor) = $event), _ctx.calcularTotalContasFechamento]
                            }, null, 8, ["valor", "onUpdate:valor"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_a_form_item, {
                          label: " ",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                              onClick: ($event: any) => (_ctx.excluirContaFechamento(index))
                            }, [
                              _createVNode(_component_icone, { nome: "excluir" })
                            ], 8, _hoisted_18)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]))
                  }), 128)),
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_a_form_item, {
                        label: " ",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.adicionarContaFechamento && _ctx.adicionarContaFechamento(...args)))
                          }, "Adicionar Conta de Fechamento")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_a_form_item, {
                        label: "Total de Transferências",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            monetario: true,
                            valor: _ctx.state.totalContasFechamento,
                            "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.totalContasFechamento) = $event)),
                            disabled: ""
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible"]))
}